import { useState } from "react";

export default function CakePreview({ prompt, productId }) {
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const generateImage = async () => {
        if (!prompt || !productId) return;
        setLoading(true);
        setError(null);

        try {
            const res = await fetch("/githiri/api/generate-image", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ prompt, product_id: productId }),
            });

            // const contentType = res.headers.get("content-type");
            // let data;

            // if (contentType && contentType.includes("application/json")) {
            //     data = await res.json();
            // } else {
            //     const text = await res.text();
            //     throw new Error(`Unexpected response: ${text}`);
            // }

            // if (!res.ok) {
            //     throw new Error(data.detail || "Image generation failed");
            // }

            // setImageUrl(data.url);


            const contentType = res.headers.get("content-type");
            let data;

            if (contentType && contentType.includes("application/json")) {
                data = await res.json();
            } else {
                // don't try to read twice — just throw based on contentType
                throw new Error(`Unexpected response type: ${contentType}`);
            }

            if (!res.ok) {
                throw new Error(data.detail || "Image generation failed");
            }

            setImageUrl(data.url);


        } catch (err) {
            console.error("Error generating image:", err);
            setError(err.message);
            setImageUrl(null);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mt-6 text-center">
            <h3 className="font-semibold mb-2">Live Preview</h3>

            <button
                onClick={generateImage}
                disabled={loading || !prompt}
                className="bg-red-600 text-white px-4 py-2 rounded shadow hover:bg-red-700 disabled:opacity-50"
            >
                {loading ? "Generating..." : "Generate Preview"}
            </button>

            {error && <p className="text-red-500 mt-2">{error}</p>}

            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt="Cake preview"
                    className="mx-auto mt-4 rounded shadow-md"
                />
            ) : !loading ? (
                <p className="text-stone-500 mt-4">Enter a prompt and click Generate Preview</p>
            ) : null}
        </div>
    );
}
